import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Persistent File Storage/errors";
import * as React from 'react';
export default {
  Content,
  React
};